(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/hr.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/hr.js');
"use strict";


const HR = _ref => {
  let {
    branding
  } = _ref;
  return React.createElement("hr", {
    className: "tg-hr tg-hr-".concat(branding || 'default')
  });
};
const mapState = state => ({
  branding: state.settings.branding
});
svs.tickets_giftshop.components.HR = ReactRedux.connect(mapState)(HR);

 })(window);